import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";
import { workflows } from "@kubdee/module-core/schemas/workflow-workflows";

// ============================================================================
// crm_leads — ลีด/ผู้สนใจ
// ============================================================================
export const crmLeads = sqliteTable("crm_leads", {
  id: text("id").primaryKey(), // ULID
  leadNo: text("lead_no"),
  companyId: text("company_id").notNull(),
  firstName: text("first_name"),
  lastName: text("last_name"),
  fullName: text("full_name"),
  email: text("email"),
  phone: text("phone"),
  mobile: text("mobile"),
  lineId: text("line_id"),
  organizationName: text("organization_name"), // text — not FK
  jobTitle: text("job_title"),
  website: text("website"),
  status: text("status", {
    enum: ["new", "contacted", "qualified", "unqualified", "converted"],
  }).notNull().default("new"),
  docStatus: integer("doc_status").notNull().default(0), // 0=Draft, 1=Submitted, 2=Cancelled
  workflowId: text("workflow_id").references(() => workflows.id),
  currentStateKey: text("current_state_key"),
  source: text("source"),
  score: integer("score").default(0),
  assignedTo: text("assigned_to"),
  convertedDealId: text("converted_deal_id"),
  convertedContactId: text("converted_contact_id"),
  convertedOrganizationId: text("converted_organization_id"),
  convertedAt: text("converted_at"),
  remarks: text("remarks"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyStatusIdx: index("lead_company_status_idx").on(table.companyId, table.status, table.createdAt),
  companyAssignedIdx: index("lead_company_assigned_idx").on(table.companyId, table.assignedTo),
}));

// Type exports
export type CrmLead = typeof crmLeads.$inferSelect;
export type NewCrmLead = typeof crmLeads.$inferInsert;
